import { IconStorage } from "@app/shared/icons/interfaces";

export const tooth: IconStorage = {
  svgCode: () => ([
    "M9.93295 2.43912C10.924 2.87245 12.0649 2.87245 13.0559 2.43912C15.3261 1.46135 19.0368 1.96135 19.8665 5.73908C20.6616 9.33903 17.6372 11.1556 17.8331 13.6666C18.1212 17.311 16.8012 21.9995 14.9574 21.9995C11.7422 21.9995 14.4042 14.2945 11.5002 14.2945C8.59619 14.2945 11.2582 22 8.04309 22C6.19928 22 4.86884 17.311 5.15693 13.6666C5.35284 11.1556 2.33876 9.35014 3.1339 5.73908C3.96362 1.96135 7.67429 1.45024 9.94448 2.43912H9.93295Z",
  ]),
};
